import React, { useState, useEffect } from 'react';
import StatCard from '../components/common/StatCard';
import { reportsAPI, studentsAPI, staffAPI, feesAPI, attendanceAPI } from '../services/api';
import { formatCurrency } from '../utils/helpers';
import EventCalendar from '../components/common/EventCalendar';

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [recentStudents, setRecentStudents] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [dashRes, studRes, staffRes, feeRes, attRes] = await Promise.allSettled([
          reportsAPI.dashboard(),
          studentsAPI.stats(),
          staffAPI.stats(),
          feesAPI.summary(),
          attendanceAPI.todaySummary(),
        ]);

        const merged = {};
        if (dashRes.status === 'fulfilled') Object.assign(merged, dashRes.value.data);
        if (studRes.status === 'fulfilled') Object.assign(merged, studRes.value.data);
        if (staffRes.status === 'fulfilled') Object.assign(merged, { ...merged, ...staffRes.value.data });
        if (feeRes.status === 'fulfilled') Object.assign(merged, feeRes.value.data);
        if (attRes.status === 'fulfilled') Object.assign(merged, attRes.value.data);
        setStats(merged);

        const studentsRes = await studentsAPI.list({ page_size: 5 });
        setRecentStudents(studentsRes.data.results || []);
      } catch (err) {
        console.log('Dashboard data fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return (
    <div className="loading-spinner">
      <div className="spinner-border text-primary" role="status" />
      <span className="ms-3">Loading dashboard...</span>
    </div>
  );


  const students = [
    {
      name: "Rahul",
      className: "6th",
      section: "Vayu",
      amount: "10,000",
    },
    {
      name: "Kiran",
      className: "7th",
      section: "Agni",
      amount: "12,000",
    },
    {
      name: "Sai",
      className: "8th",
      section: "Jal",
      amount: "15,000",
    },
    {
      name: "Ravi",
      className: "9th",
      section: "Prithvi",
      amount: "18,000",
    },
  ];
  const scrollingData = [...students, ...students];

  return (
    <div>
      {/* Stats Row */}
      <div className="row g-3 mb-4">
        <div className="col-6 col-lg-3">
          {/* <i class="lni lni-graduation-cap-1"></i> */}
          <StatCard icon={<i className="lni lni-graduation-cap-1"></i>} label="Total Students" value={stats.total_students || stats.total || 0} color="blue" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard icon={<i className="lni lni-user-multiple-4"></i>} label="Total Staff" value={stats.teachers || stats.total_staff || 0} color="green" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard icon={<i className="lni lni-check-circle-1"></i>} label="Present Today" value={stats.present || stats.today_student_attendance || 0} color="teal" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard
            icon={<i className="lni lni-rupee"></i>}
            label="Fee Collected"
            value={formatCurrency(stats.total_collected || stats.fee_collected_month || 0)}
            color="purple"
          />
        </div>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-6 col-lg-3">
          <StatCard icon={<i className="bi bi-exclamation-circle"></i>} label="Pending Fees" value={stats.pending_fees || stats.pending_count || 0} color="orange" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard icon={<i className="bi bi-person-standing"></i>} label="Male Students" value={stats.male || 0} color="blue" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard icon={<i className="bi bi-person-standing-dress"></i>} label="Female Students" value={stats.female || 0} color="pink" />
        </div>
        <div className="col-6 col-lg-3">
          <StatCard icon={<i className="bi bi-buildings"></i>} label="Active Students" value={stats.active || 0} color="green" />
        </div>
      </div>

      {/* Content Row */}
      <div className="row g-3">
        {/* Recent Students */}
        {/* <div className="col-lg-8">
          <div className="card">
            <div className="card-header">
              <span className=' '> <i className="bi bi-file-earmark-richtext fs-5 text-info me-2"></i> Recent Students</span>
              <a href="/students" className="btn btn-sm btn-outline-primary">View All</a>
            </div>
            <div className="card-body p-0">
              <table className="table mb-0">
                <thead>
                  <tr>
                    <th>Admission #</th>
                    <th>Name</th>
                    <th>Class</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {recentStudents.length === 0 ? (
                    <tr><td colSpan={4} className="text-center text-muted py-4">No students yet</td></tr>
                  ) : (
                    recentStudents.map((s) => (
                      <tr key={s.id}>
                        <td><code style={{ fontSize: 12 }}>{s.admission_number}</code></td>
                        <td><strong>{s.full_name || `${s.first_name} ${s.last_name}`}</strong></td>
                        <td>{s.class_name || '—'}</td>
                        <td><span className={`status-badge ${s.status}`}>{s.status}</span></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div> */}

        <div className='col-lg-4'>
           <EventCalendar/>
          {/* <div className='card'>
            <div className='card-header'> <span><i className="bi bi-calendar2-check me-2"></i> Events Calender</span> </div>
            <div className='card-body'>
             
            </div>
          </div> */}
        </div>

        <div className='col-lg-4'>
          <div className='card'>
            <div className='card-header'>
              <span className='fs-5'>Outstanding fee payment</span>
              <div>
                <select className='form-select form-select-sm' style={{width:"130px"}}>
                <option>Select Class</option>
                <option>All Classes</option>
                <option>Class 1</option>
                <option>Class 2</option>
                <option>Class 3</option>
                <option>Class 4</option>
                <option>Class 5</option>
              </select>
              </div>
            </div>
              
            <div className='card-body'>
              <div className="marquee-container">
                <div className="marquee-track">

                  {scrollingData.map((student, index) => {
                    return <div key={index}>
                      <h6 className='mb-0'>{student.name}</h6>
                      <div>
                        Class: <span>{student.className}</span>,
                        Section: <span>{student.section}</span>,
                        {" "} Rs:<span className="text-danger fw-bold">{student.amount}</span>
                        <div>Ph: 9876543210</div>
                      </div>
                      <hr />
                    </div>

                  })}

                  {/* <div>
                    <h6 className='text-info'>Rahul</h6>
                    <div>Class: <span>6th</span>, Section: <span>Vayu</span> Rs:<span className='text-danger fw-bold'>10,000</span></div>
                  </div>
                  <hr />
                  <div>
                    <h6 className='text-info'>Rahul</h6>
                    <div>Class: <span>6th</span>, Section: <span>Vayu</span> Rs:<span className='text-danger fw-bold'>10,000</span></div>
                  </div>
                  <hr />
                  <div>
                    <h6 className='text-info'>Rahul</h6>
                    <div>Class: <span>6th</span>, Section: <span>Vayu</span> Rs:<span className='text-danger fw-bold'>10,000</span></div>
                  </div>
                  <hr />
                  <div>
                    <h6 className='text-info'>Rahul</h6>
                    <div>Class: <span>6th</span>, Section: <span>Vayu</span> Rs:<span className='text-danger fw-bold'>10,000</span></div>
                  </div>
                  <hr /> */}

                </div>
              </div>
            </div>
          </div>
        </div>       


        {/* Quick Links */}
        <div className="col-lg-4">
          <div className="card">
            <div className="card-header"><span>⚡ Quick Actions</span></div>
            <div className="card-body">
              {[
                { href: '/students', icon: '➕', label: 'Admit New Student', color: '#eff6ff' },
                { href: '/attendance', icon: '✅', label: 'Mark Attendance', color: '#f0fdf4' },
                { href: '/fees', icon: '💳', label: 'Collect Fee', color: '#faf5ff' },
                { href: '/examination', icon: '📝', label: 'Enter Results', color: '#fff7ed' },
                { href: '/communication', icon: '📢', label: 'Send Announcement', color: '#fef2f2' },
                { href: '/reports', icon: '📊', label: 'Generate Report', color: '#f0fdfa' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    padding: '10px 14px', borderRadius: 8,
                    background: item.color, marginBottom: 8,
                    textDecoration: 'none', color: '#0f172a',
                    fontSize: 13, fontWeight: 600,
                    transition: 'transform 0.15s',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(4px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
                >
                  <span style={{ fontSize: 18 }}>{item.icon}</span>
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
